<template>
	<div>
		<el-dialog title="请选择专业" width="500px" :visible.sync="visible" :close-on-click-modal="false" @close="closeMajor">
			<div v-for="item in dataList" :key="item.id" class="majoritem" @click="checkMajor(item)">
				<span style="font-weight: bold; margin-right: 10px;">{{item.item_num}}</span>
				<span>{{item.title}}/</span><span style="color: #000;">{{item.item_desc}}</span>
				<span style="margin-left: 10px; color: #1370FB;">( {{item.students}}/{{item.plan_num||item.item_plan}} )</span>
				<span></span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props:['major_id',"filter_xz"],
		data() {
			return {
				visible: true,
				closing:false,
				dataList:[],
				isadmin:this.$store.state.teacherRole.isadmin
			}
		},
		mounted() {
			this.getList()
			
		},
		methods: {
			getList(){
				this.$http.post("/api/getMajorZSdata").then(res=>{
					let para=[];
					console.log('this.filter_xz')
					console.log(this.filter_xz)
					if(this.filter_xz){
						let xz = ''
						for(let item of res.data){
							if(item.id==this.major_id){
								console.log(item.item_desc)
								xz = item.item_desc
								break
							}
						}
						
						if(!xz){
							para = res.data
						}else{
							for(let item of res.data){
								if(xz==item.item_desc){
									para.push(item)
									
								}
							}
						}
						
					}else{
						para = res.data
					}
					
					this.dataList = para
				})
			},
			getRole(){//检查用户角色，如果是管理员则可以在招满之后新增
				this.$http.post("/api/get_teacher_role").then(res=>{
					
					for(let item of res.data){
						if(item.role_code.toLowerCase().indexOf("admin")>=0){
							this.isadmin = true;
							break
						}
					}
				})
			},
			checkMajor(item){
				//检查是否管理员
				if((item.plan_num||item.item_plan)<=item.students&&!this.isadmin){//已招满
					this.$message({
						type: 'error',
						message: '该专业已招满，无法录入！',
						offset:"500"
					});
				}else{
					this.visible = false;
					this.closing = true
					setTimeout(()=>{
						this.$parent.closeMajor(item);
						
					},250)
				}
				
			},
			closeMajor(){
				if(this.closing){
					return
				}
				this.visible = false;
				
				setTimeout(()=>{
					this.$parent.closeMajor(null);
					
				},250)
			}
		}
	}
</script>
<style scoped="scoped">
	.majoritem{ border-bottom: 1px solid #ccc; padding: 5px ; cursor: pointer;}
	.majoritem:hover{background-color: #CCCCCC;}
</style>
